let store = {};

const MemoryStorage = {
  setItem: (key, value) => {
    store[key] = value;
    return true;
  },
  getItem: (key) => store[key],
  removeItem: (key) => {
    delete store[key];
    return true;
  },
  key: (n) => Object.keys(store)[n],
  clear: () => (store = {}),
};

export default MemoryStorage;
